import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { Card } from 'components/Card';
import { Loader } from 'components/Loader';
import { BaseComponent } from 'components/BaseComponent';
import { List, Row, Cell } from '../../../components/List';
import { Input } from '../../../components/Input';
import { fetchInspectionStatistics } from '../actions';
import { FETCH_INSPECTION_STATS } from '../constants';
import { selectWork } from '../../Api/selectors';
import { selectInspectionStats } from '../selectors';
import "./style.scss";

const Container = styled.div`
  padding: 20px;
`;

const StatCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);

  h2 {
    margin: 0 0 8px 0;
    font-size: 32px;
    font-weight: bold;
    color: #2c3038;
  }

  p {
    margin: 0;
    color: #666;
    font-size: 14px;
  }
`;

const STATE = {
  selectedDate: new Date().toISOString().split('T')[0],
};

class InspectionStatsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.getInspectionStatistics(this.state.selectedDate);
  }

  onDateChange(e) {
    this.setState({ selectedDate: e.target.value }, () => {
      this.props.getInspectionStatistics(this.state.selectedDate);
    });
  }

  render() {
    const { selectedDate } = this.state;
    const { work, inspectionStats } = this.props;
    const loading = work;
    const data = inspectionStats;

    return (
      <Container>
        <Card headerTitle="Inspectie Statistieken">
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              Selecteer datum:
            </label>
            <Input
              type="date"
              value={selectedDate}
              onChange={this.onDateChange.bind(this)}
              style={{ maxWidth: '200px' }}
            />
          </div>

          {loading && <Loader onCard />}

          {!loading && data && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                <StatCard>
                  <h2>{data.total}</h2>
                  <p>Totaal geïnspecteerd</p>
                </StatCard>

                <StatCard>
                  <h2>{data.user_12317_count || 0}</h2>
                  <p>Door user 12317</p>
                </StatCard>

                <StatCard>
                  <h2>{data.other_users_count || 0}</h2>
                  <p>Door andere users</p>
                </StatCard>
              </div>

              {data.vehicles && data.vehicles.length > 0 && (
                <Card headerTitle="Geïnspecteerde voertuigen">
                  <List>
                    {data.vehicles.map((vehicle, index) => (
                      <Row
                        key={vehicle.id}
                        onClick={() => this.to(`/vehicles/${vehicle.id}`)}
                        style={{ cursor: 'pointer' }}
                      >
                        <Cell style={{ width: '60px' }}>{index + 1}</Cell>
                        <Cell style={{ flex: 1 }}>
                          <strong>
                            {vehicle.brand_name} {vehicle.model_name}
                          </strong>
                        </Cell>
                        <Cell style={{ width: '150px' }}>{vehicle.regplate || '-'}</Cell>
                        <Cell style={{ width: '180px' }}>
                          {vehicle.inspection_done_date
                            ? new Date(vehicle.inspection_done_date.replace(' ', 'T')).toLocaleString('nl-NL', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit',
                              })
                            : '-'}
                        </Cell>
                        <Cell style={{ width: '200px' }}>
                          {vehicle.inspected_by?.email_address || '-'}
                        </Cell>
                      </Row>
                    ))}
                  </List>
                </Card>
              )}

              {data.vehicles && data.vehicles.length === 0 && (
                <p style={{ textAlign: 'center', color: '#666', padding: '20px' }}>
                  Geen voertuigen geïnspecteerd op deze datum
                </p>
              )}
            </>
          )}
        </Card>
      </Container>
    );
  }
}

InspectionStatsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork([FETCH_INSPECTION_STATS]),
    inspectionStats: selectInspectionStats(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    getInspectionStatistics(date) {
      dispatch(fetchInspectionStatistics(date));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InspectionStatsPage = compose(
  withRouter,
  withConnect,
)(InspectionStatsComp);
